import styled, { keyframes } from "styled-components";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useEffect, useState, ChangeEvent } from "react";
import AllyService from "../../../services/ally.service";
import { Reservation, Tour, PaymentMethods, TourInfo, Ally } from "../../../types/common.types";
import InputDropdown from "../../common/InputDropdown";
import ToursService from "../../../services/tours.service";
import GeneralInput from "../../common/GeneralInput";
import Calendar from "../../common/CalendarInput";
import { format } from "date-fns";
import removeTimezone from "../../../utils/removeTimezone";
import { Summary } from "../../../types/seller";
import { useGlobal } from "../../../context/global";
import { useAlly } from "../../../context/ally";
import Select from "../../common/Select";

export default function EditReservation() {
    const { setIsLoading } = useGlobal()
    const { setEditReservationId, editReservationId, setSummary, setNewGroupReservations, user } = useAlly()
    const [data, setData] = useState<Reservation>({} as Reservation)
    const [tours, setTours] = useState<Tour[]>([])
     const [tour, setTour] = useState<TourInfo>()
     const [me, setMe] = useState<Ally>()

    useEffect(() => {
        async function fetchTours() {
            if (!data.tour_id) return
            try {
                const response = await ToursService.getDetailTourInfo(data?.tour_id || '', user?.user.agency_id || '')
                setTour(response.data)
            } catch (error) {
                console.error('Error fetching tours:', error)
            }
        }
        fetchTours()
    }, [data.tour_id, user?.user.agency_id])

    useEffect(() => {
        async function getInfo() {
            setIsLoading(true)
            try {
                const response = (await AllyService.getReservation(editReservationId)).data
                setData(response)
            } catch (error) {
                console.log(error)
            }
            try {
                const response = await (await ToursService.list()).data
                setTours(response)
            } catch (error) {
                console.log(error)
            }
            try {
                const responseMe = await AllyService.me()
                setMe(responseMe.data)
            }
            catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        getInfo()
    }, [editReservationId])

    async function onSubmit() {
        if (data?.reservation_date && data?.tour_id) {
            const price = me?.tour_prices?.find(tp => tp.tour_id === data.tour_id)?.price || 0
            if (!price) return
            if (!data.tour_id || !data.reservation_date) return
            if (!tours.some(tour => tour.id === data.tour_id)) return
            const newData: Reservation = {
                tour_id: data.tour_id,
                reservation_date: new Date(data.reservation_date),
                tickets: data.tickets,
                price: price,
                ticket_included: data.ticket_included,
                cost: data.cost
            } as Reservation
            try {
                setIsLoading(true)
                await AllyService.editReservation(editReservationId, newData)
                setSummary((prev) => {
                    const oldItem = prev.find(item => item.reservation.id === editReservationId)
                    const filtered = prev.filter(item => item.reservation.id !== editReservationId)
                    return ([...filtered, {...oldItem, reservation: {...oldItem!.reservation, ...newData}}] as Summary[])
                })
                setNewGroupReservations((prev) => {
                    const oldItem = prev.find(item => item.id === editReservationId)
                    const filtered = prev.filter(item => item.id !== editReservationId)
                    return ([...filtered, {...oldItem, ...newData}] as Reservation[])
                })
                setEditReservationId('')
            } catch (error) {
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
    }

    return (
        <Main>
            <Modal>
                <div className="close" title="close"
                    onClick={() => setEditReservationId('')}
                >
                    <AiOutlineCloseCircle/>
                </div>
                <h1>Edit reservation</h1>
                {
                    tours.length > 0 &&
                    <InputDropdown
                    options={tours}
                    keys={['id']}
                    value={data.tour_id}
                    selector="id"
                    optionDefaultHeight={35}
                    onChange={async (newValue: string) => {
                        const newPrice = me?.tour_prices?.find(tp => tp.tour_id === newValue)?.price || 0
                        setData(prevData => ({...prevData, tour_id: newValue, price: newPrice}))
                        const response = await ToursService.getDetailTourInfo(newValue, user?.user.agency_id || '')
                        setTour(response.data)
                    }}
                    />
                }
                {
                    data.reservation_date &&
                    <div 
                    style={{margin: '20px 0'}}
                    className="calendar">
                        <Calendar
                        selectedDay={data.reservation_date}
                        setSelectedDay={(newDate: Date) => setData(prevData => ({...prevData, reservation_date: newDate}))}
                        />
                        {typeof data.reservation_date === 'string' ? removeTimezone(data.reservation_date) : format(data.reservation_date, 'dd/MM/yyyy')}
                    </div>
                }
                <Select 
                options={[{name: 'INCLUIDO', value: 'true'}, {name: 'LLEVA CASH', value: 'false'}]}
                label="Ticket included"
                onChange={e => setData(prev => ({...prev, ticket_included: e.target.value === 'true'}))}
                defaultNull
                defaultValue={''}
                />
                <GeneralInput
                label="Price"
                type="number"
                value={data.price || ''}
                disabled={true}
                style={{margin: '20px 0'}}
                />
                <GeneralInput
                label="Cost"
                type="number"
                value={data.cost || ''}
                onChange={e => setData(prevData => ({...prevData, cost: Number(e.target.value)}))}
                />
                <button 
                type="submit"
                onClick={onSubmit}
                >Submit</button>
            </Modal>
        </Main>
    )
}

const Main = styled.div`
z-index: 100;
position: fixed;
top: 0;
left: 0;
width: 100vw;
height: 100vh;
background-color: ${props => props.theme.blackTransparent};
`
const showUpModal = keyframes`
    from {
        top: 100%;
    }
    to {
        top: 50%;
    }
`

const Modal = styled.div`
width: 80%;
max-height: 75%;
overflow: hidden;
overflow-y: unset;
max-width: 500px;
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
background-color: ${props => props.theme.white};
box-shadow: 0 0 20px ${props => props.theme.blackTransparent};
padding: 20px;
animation: ${showUpModal} .3s ease forwards;
.close {
    position: absolute;
    right: 20px;
    top: 20px;
    font-size: 22px;
    cursor: pointer;
}
h1 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
}
.payment_method {
    margin-bottom: 10px;
    position: relative;
    button {
        position: absolute;
        right: 0;
        top: 0;
        height: 25px;
        width: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        background-color: rgba(0,0,0,0);
        border-radius: 50%;
        cursor: pointer;
        border: 1px solid ${props => props.theme.dark};
    }
    h4 {
        font-weight: 400;
        margin-bottom: 5px;
    }
    label {
        text-transform: capitalize;
    }
}
> button.back {
    background-color: rgba(0,0,0,0);
    border: none;
    font-size: 20px;
    cursor: pointer;
    transition: transform .3s ease;
    &:hover {
        transform: translateY(-3px);
    }
}
h3.payment-title {
    font-weight: 500;
    margin-bottom: 10px;
}
> .calendar {
    display: flex;
    gap: 10px;
    align-items: center;
}
> button {
    margin-top: 20px;
    display: inline-block;
    padding: 0 10px;
    height: 2.6em;
    line-height: 2.5em;
    overflow: hidden;
    font-size: 17px;
    z-index: 1;
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.blue};
    border: 2px solid ${props => props.theme.blue};
    border-radius: 6px;
    position: relative;
    cursor: pointer;
}

> button::before {
    position: absolute;
    content: "";
    background: ${props => props.theme.blue};
    width: calc(100% + 100px);
    height: 200px;
    z-index: -1;
    border-radius: 50%;
}

> button:hover {
    color: ${props => props.theme.white};
}

> button:before {
    top: 100%;
    left: 100%;
    transition: .3s all;
}

> button:hover::before {
    top: -30px;
    left: -30%;
}
`